import I18n from "i18n-js";
import React from "react"

class ReservationSegmentScoreDataType extends React.Component{
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="ReservationSegmentScoreDataType">
        { this.props.row.rating
          ? <div>{`${this.props.row.rating} ${I18n.t('out_of')} ${5}`}</div> 
          : <div><i>{I18n.t('none')}</i></div>
        }
      </div>
    )  
  }
};

export default ReservationSegmentScoreDataType